module.exports = __webpack_public_path__ + "static/po-21c23229b981a7a5beca475672c5920b.svg";